import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-message-circle" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-instagram" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-share" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_bottom_pop_up_item, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('switchState', _ctx.CASE_SHARE_POPUP_STATES.SHARE_BY_MESSAGE)))
    }, {
      icon: _withCtx(() => [
        _hoisted_1
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$localize('share.photo.popup.message')) + " ", 1)
      ]),
      _: 1
    }),
    (_ctx.isInstagramShareEnabled)
      ? (_openBlock(), _createBlock(_component_bottom_pop_up_item, {
          key: 0,
          onClick: _ctx.shareOnInstagram
        }, {
          icon: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$localize('share.photo.popup.instagram')) + " ", 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_bottom_pop_up_item, {
      onClick: _ctx.onCopy,
      class: _normalizeClass(_ctx.driveStore.currentCase.accessedByExternalUrl ? '' : 'disabled')
    }, {
      icon: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass(["icon icon-copy-content", _ctx.copied ? 'icon-copy-content-success' : 'icon-copy-content'])
        }, null, 2)
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$localize('share.case.popup.copy')) + " ", 1)
      ]),
      _: 1
    }, 8, ["onClick", "class"]), [
      [_vShow, _ctx.currentPage === _ctx.NAVIGATION_PAGES.CASE_VIEW]
    ]),
    _withDirectives(_createVNode(_component_bottom_pop_up_item, {
      onClick: _ctx.shareLink,
      class: _normalizeClass(_ctx.currentPage === _ctx.NAVIGATION_PAGES.CASE_VIEW && _ctx.driveStore.currentCase.accessedByExternalUrl ? '' : 'disabled')
    }, {
      icon: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$localize('share.case.popup.url')) + " ", 1)
      ]),
      _: 1
    }, 8, ["onClick", "class"]), [
      [_vShow, _ctx.mainStore.isNative]
    ])
  ]))
}